var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.50012H6C5.17157 4.50012 4.5 5.1717 4.5 6.00012V14.4395L5.40901 13.5304C6.28769 12.6518 7.71231 12.6518 8.59099 13.5304L9.46967 14.4091C9.76256 14.702 10.2374 14.702 10.5303 14.4091L13.4634 11.4761C14.3096 10.6299 15.67 10.5941 16.5595 11.3947L19.5 14.0411V6.00012C19.5 5.1717 18.8284 4.50012 18 4.50012ZM4.5 18.0001V16.5592C4.51031 16.5499 4.52042 16.5404 4.53033 16.5304L6.46967 14.5911C6.76256 14.2982 7.23744 14.2982 7.53033 14.5911L8.40901 15.4698C9.28769 16.3485 10.7123 16.3485 11.591 15.4698L14.524 12.5368C14.8061 12.2547 15.2596 12.2428 15.5561 12.5096L19.4983 16.0576L19.5 16.0591V18.0001C19.5 18.8285 18.8284 19.5001 18 19.5001H6C5.17157 19.5001 4.5 18.8285 4.5 18.0001ZM6 3.00012C4.34315 3.00012 3 4.34327 3 6.00012V18.0001C3 19.657 4.34315 21.0001 6 21.0001H18C19.6569 21.0001 21 19.657 21 18.0001V6.00012C21 4.34327 19.6569 3.00012 18 3.00012H6ZM8.5 10.0001C9.32843 10.0001 10 9.32855 10 8.50012C10 7.67169 9.32843 7.00012 8.5 7.00012C7.67157 7.00012 7 7.67169 7 8.50012C7 9.32855 7.67157 10.0001 8.5 10.0001Z",
    fill: "#081B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/Photo.9a571fa4a6175cf3f3b90c902cb6a07e.svg";
export { ForwardRef as ReactComponent };